import { render, staticRenderFns } from "./NeckData.vue?vue&type=template&id=2363c468&scoped=true&"
import script from "./NeckData.vue?vue&type=script&lang=js&"
export * from "./NeckData.vue?vue&type=script&lang=js&"
import style0 from "./NeckData.vue?vue&type=style&index=0&id=2363c468&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2363c468",
  null
  
)

export default component.exports